/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { addSeminarRecruitment, editSeminarRecruitment, seminarCategories, seminarSessions } from '../../apis/admin/seminar';
import { addressToCoord } from '../../apis/maps';
import useForm from '../../hooks/useForm';
import { isEmpty } from '../../utils/lodashExtend';
import { toast } from '../../utils/toast';
import Form from '../Form';
import Session from './Session';
import { dateToFormat, format, formatDateHour, getDay, getWeekRangeDateTime } from '../../utils/date';
import { getRegions } from '../../apis/code';
import systemAlert from '../../utils/systemAlert';
import Modal, { ModalHeader } from '../Modal';
import { isArray, remove } from 'lodash';
import { isNumber } from 'lodash';
import { SEMINAR_PERIODIC_CYCLE_UNIT, SEMINAR_STATUS } from '../../constants/SEMINAR_TYPE';
import TabList from '../Tab';
import DatePicker from '../DatePicker';
import Button from '../Button';
import Radios from '../Radio/Radios';
import { get } from 'lodash';


const defaultForm = {
  maxPeople: "0",
  price: "0",
  isRecruitmentDuplicateParticipation: "false",
  seminarStartTime: getWeekRangeDateTime().from,
  seminarEndTime: getWeekRangeDateTime().to,
  reruitmentStartTime: getWeekRangeDateTime().from,
  reruitmentEndTime: getWeekRangeDateTime().to,
  place: "",
  longitude: "",
  latitude: "",
  refundPolicy: "",
  session: "",
  regionCode: "1",
  address: "",
  addressDetail: "",
  zipCode: "",
  autoApproval: "false",
  isHide: "false",
  title: "",
  slogan: "",
  recommendNumber: "0",
  mapUrl: "",
  type: "single",
  periodicCycleUnit: "week",
};

const Recruitment = (props) => {
  const { open, setOpen, submit, selectedItem, setSelectedItem } = props;
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState("create");
  const [sessionList, setSessionList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [sessionOpen, setSessionOpen] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [content, setContent] = useState("");
  const [active, setActive] = useState("recruitment");

  const defaultCancelSchedule = {
    cancelDate: getDay(),
    isChange_0: "false",
    startDate: getDay(),
    endDate: getDay(),
  };

  const [cancelScheduleList, setCancelScheduleList] = useState([defaultCancelSchedule]);



  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    submit && submit();
    if (setSelectedItem) {
      setSelectedItem(null);
    }
    setActive('recruitment');
    setCancelScheduleList([defaultCancelSchedule]);
  };

  const _submit = (form) => {
    const thumbnailIdx = !isEmpty(form.thumbnailFile)
      ? isNumber(form.thumbnailFile[form.thumbnailFile.length - 1])
        ? form.thumbnailFile[form.thumbnailFile.length - 1]
        : form.thumbnailFile[form.thumbnailFile.length - 1]?.fileIdx
      : null;
    const mainImageIdx = !isEmpty(form.mainImageFile)
      ? isNumber(form.mainImageFile[form.mainImageFile.length - 1])
        ? form.mainImageFile[form.mainImageFile.length - 1]
        : form.mainImageFile[form.mainImageFile.length - 1]?.fileIdx
      : null;
    const data = {
      ...form,
      seminarStartTime: isArray(form.seminarStartTime)
        ? dateToFormat(form.seminarStartTime[0], formatDateHour) + ":00"
        : dateToFormat(form.seminarStartTime, formatDateHour) + ":00",
      seminarEndTime: isArray(form.seminarEndTime)
        ? dateToFormat(form.seminarEndTime[0], formatDateHour) + ":00"
        : dateToFormat(form.seminarEndTime, formatDateHour) + ":00",
      reruitmentStartTime: isArray(form.reruitmentStartTime)
        ? dateToFormat(form.reruitmentStartTime[0], formatDateHour) + ":00"
        : dateToFormat(form.reruitmentStartTime, formatDateHour) + ":00",
      reruitmentEndTime: isArray(form.reruitmentEndTime)
        ? dateToFormat(form.reruitmentEndTime[0], format) + " 23:59:00"
        : dateToFormat(form.reruitmentEndTime, format) + " 23:59:00",
      price: +form.price,
      thumbnailIdx,
      mainImageIdx,
      cancelScheduleList: cancelScheduleList.map((item, idx) => {
        const isChange = item[`isChange_${idx}`] === "true";
        const result = {
          cancelDate: item.cancelDate,
          isChange,
          ...(isChange && (
            {
              startDate: item.startDate,
              endDate: item.endDate,
            }
          ))
        };
        delete result[`isChange_${idx}`];
        return result;
      })
    };

    let promise;

    if (mode === "create") {
      delete data.idx;
      promise = addSeminarRecruitment(data);
    } else {
      promise = editSeminarRecruitment(data, selectedItem.idx);
    }

    promise.then(() => {
      toast.success(`${mode === "create" ? "등록" : "수정"}이 완료되었습니다.`);
      cancel();
    }).catch(err => {
      console.error(err);
    });
  };


  const getCoord = async (form, setForm) => {
    if (form.address) {
      const address = form.address;
      const addresses = await addressToCoord({ address });
      if (addresses.length > 0) {
        form.latitude = addresses[0].y;
        form.longitude = addresses[0].x;
        setForm({ ...form });
      } else {
        toast.error("주소를 정확히 입력해주세요");
      }
    } else {
      toast.error("주소 입력 후 변환해 주세요.");
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    getSessions();
    getCategories();
  }, []);

  useEffect(() => {
    if (!isEmpty(sessionList)) {
      setMode(selectedItem ? 'detail' : 'create');
      if (!isEmpty(selectedItem)) {
        setForm({
          ...selectedItem,
          isHide: selectedItem.isHide + "",
          autoApproval: selectedItem.autoApproval + "",
          isRecruitmentDuplicateParticipation: selectedItem.isRecruitmentDuplicateParticipation + "",
          price: selectedItem.price + "",
          maxPeople: selectedItem.maxPeople + "",
          session: selectedItem.sessionIdx,
        });

        setOriginForm({
          ...selectedItem,
          isHide: selectedItem.isHide + "",
          autoApproval: selectedItem.autoApproval + "",
          isRecruitmentDuplicateParticipation: selectedItem.isRecruitmentDuplicateParticipation + "",
          price: selectedItem.price + "",
          maxPeople: selectedItem.maxPeople + "",
          session: selectedItem.sessionIdx,
        });

        setCheckedList(selectedItem.seminarCategories?.map(item => item.idx + "") || []);
        setCancelScheduleList((selectedItem?.cancelScheduleList || []).map((item, idx) => {
          const result = {
            ...item,
            [`isChange_${idx}`]: item.isChange + ""
          };
          return result;
        }));

      } else {
        setForm({
          ...defaultForm,
          ...getSessionDefaultData(),
        });

        setOriginForm({
          ...defaultForm,
          ...getSessionDefaultData(),
        });
      }
    }
  }, [open, selectedItem, sessionList]);

  useEffect(() => {
    if (!isEmpty(form.session)) {
      setForm(getSessionDefaultData(+form.session));
    }
  }, [form.session]);

  const getSessionDefaultData = (sessionIdx = (sessionList || [])[0]?.idx) => {
    const session = sessionList.find(f => f.idx === sessionIdx) || {};
    setCheckedList((session.seminarCategories || []).map(item => `${item.idx}`));

    return {
      sessionIdx: session.idx,
      maxPeople: session.maxPeople + "" || "0",
      price: session.price + "" || "0",
      isRecruitmentDuplicateParticipation: session?.seminar?.isRecruitmentDuplicateParticipation + "" || "false",
      title: session.title,
      lecturer: session.lecturer,
      content: session.content,
      refundPolicy: session.refundPolicy || "",
      target: session.target || "",
      topic: session.topic || "",
      thumbnailFile: !isEmpty(session.thumbnailFile) ? session.thumbnailFile : [],
      seminarTime: session.seminarTime || "",
      slogan: session.slogan || "",
    };
  };

  const getCategories = () => {
    seminarCategories({ isHideView: true }).then(res => {
      setCategories(res.rows?.map(item => ({ ...item, label: item.name, value: item.idx + "" })));
    });
  };

  const getSessions = (_form = {}) => {
    seminarSessions().then(item => {
      setSessionList(item.rows);
      if (!isEmpty(item.rows) && isEmpty(_form.seminarSession)) {
        handleOnChange({ seminarSession: item.rows[0].idx + "" });
      }
    });
  };

  const reloadFields = () => {
    getSessions();
    setTimeout(() => {
      setFields(getFields());
    }, 500);
    setFields([]);
  };

  const getFields = () => {
    const _fields = [
      [
        {
          title: "시즌 선택",
          key: "session",
          type: "select",
          className: "zIndex-0",
          options: {
            list: () => {
              return [
                ...sessionList.map(item => {
                  return {
                    label: item.title,
                    value: item.idx + "",
                  };
                })
              ];
            }
          },
          isHide: () => active === "date",
        },
        {
          title: <></>,
          type: "button",
          color: "gray-line",
          label: "시즌 등록하기",
          isHide: () => active === "date",
          action: () => {
            setSessionOpen(true);
          }
        },

      ],
      [
        {
          title: "카테고리 선택",
          key: "categories",
          type: "checkboxes",
          required: true,
          className: "margin-right-16",
          checkedList,
          options: {
            list: categories || [],
          },
          isHide: () => active === "date",
          onChange: (checked, value) => {
            let _selectedCheckboxes = [];
            if (checked) {
              _selectedCheckboxes = [...checkedList, value];
            } else {
              _selectedCheckboxes = remove(checkedList, (v) => v !== value);
            }
            setCheckedList(_selectedCheckboxes);
          }
        },
      ],
      [
        {
          title: "자동 승인 여부",
          key: "autoApproval",
          type: "radio",
          options: {
            list: [{ label: '자동승인', value: "true" }, { label: '직접승인', value: "false" }]
          },
          isHide: () => active === "date",

          onChange: (e) => {
            if (e.target) {
              const { value } = e.target;

              if (value === "true" && mode === "update") {
                systemAlert("자동승인 여부 변경 이전 예약 신청의 경우 예약 상태가 변경되지 않습니다.\n 세미나 예약관리에서 예약 상태 변경이 가능합니다.");
              }
              handleOnChange(e);
            }
          }
        },
        {
          title: "목록 노출 여부",
          key: "isHide",
          type: "radio",
          options: {
            list: [{ label: '노출', value: "false" }, { label: '숨김', value: "true" }]
          },
          isHide: () => active === "date",
        },
      ],
      [
        {
          title: "중복 신청 여부",
          key: "isRecruitmentDuplicateParticipation",
          type: "radio",
          options: {
            list: [{ label: '가능', value: "true" }, { label: '불가능', value: "false" }]
          },
          isHide: () => active === "date",
        },
        {
          title: "최대인원",
          key: "maxPeople",
          type: "number",
          isHide: () => active === "date",
        },
      ],
      [
        {
          title: "신규교육 노출 순번",
          key: "recommendNumber",
          type: "number",
          isHide: () => active === "date",
        },
        {
          title: "금액",
          key: "price",
          type: "input",
          validators: ['comma'],
          isHide: () => active === "date",
        },
      ],
      [
        {
          title: "썸네일",
          type: "file-upload",
          key: "thumbnailFile",
          required: false,
          isAdmin: true,
          changeDefaultFile: true,
          isHide: () => active === "date",
        },
      ],
      [
        {
          key: "title",
          title: "제목",
          type: "input",
          required: true,
          isHide: () => active === "date",
        },
        {
          key: "topic",
          title: "주제",
          type: "input",
          isHide: () => active === "date",
        },
      ],
      [
        {
          key: "slogan",
          title: "슬로건",
          isHide: () => active === "date",
          type: "input",
        }
      ],
      [
        {
          title: "강연자",
          type: "input",
          isHide: () => active === "date",
          key: "lecturer"
        },
        {
          key: "target",
          title: "대상",
          type: "input",
          isHide: () => active === "date",
        },
      ],
      [
        {
          title: "세미나 일정",
          key: "seminarTime",
          type: "input",
          isHide: () => active === "date",
        },
      ],
      [
        {
          title: "대표이미지",
          type: "file-upload",
          key: "mainImageFile",
          required: false,
          isAdmin: true,
          changeDefaultFile: true,
          isHide: () => active === "date",
        },
      ],
      [
        {
          title: "주소",
          type: "address",
          // required: true,
          isHide: () => active === "date",
        },
      ],
      [
        {
          title: "지도 주소 URL",
          key: "mapUrl",
          isHide: () => active === "date",
          type: "input",
        }
      ],
      [
        {
          title: "장소",
          type: "input",
          key: "place",
          required: true,
          isHide: () => active === "date",
        },
        {
          title: "검색지역",
          key: "regionCode",
          type: "select",
          className: "zIndex-0",
          required: true,
          isHide: () => active === "date",
          options: {
            list: async () => {
              const item = await getRegions();
              return [
                { code: "0", label: "선택안함" },
                ...item.data.regionCodes.map(item => {
                  return {
                    label: item.region,
                    value: item.code,
                  };
                }),
                {
                  label: '온라인',
                  code: '0'
                }
              ];
            }
          },
        },
      ],
      [
        {
          title: "경도",
          key: "longitude",
          type: "input",
          placeholder: "경도 입력",
          isHide: () => active === "date",
        },
        {
          title: "위도",
          key: "latitude",
          type: "input",
          placeholder: "위도 입력",
          isHide: () => active === "date",
        },
      ],
      [
        {
          title: <></>,
          type: "button",
          color: "gray-line",
          label: "주소를 좌표로 변환",
          action: () => getCoord(form, setForm),
          disabled: !form.address,
          isHide: () => active === "date",
        },
      ],
      [
        {
          title: "대표이미지",
          type: "file-upload",
          key: "mainImageFile",
          required: false,
          isAdmin: true,
          changeDefaultFile: true,
          isHide: () => active === "date",
        },
      ],
      [
        {
          title: "내용",
          key: "content",
          type: "editor",
          required: true,
          onChange: (e) => {
            setContent(e);
          },
          isHide: () => active === "date",
        },
      ],

      [
        {
          title: "모집 유형",
          type: "radio",
          key: "type",
          options: {
            list: SEMINAR_STATUS
          },
          isHide: () => active === "recruitment"
        },

      ],
      [
        {
          title: "정기 유형",
          type: "select",
          key: "periodicCycleUnit",
          options: {
            list: SEMINAR_PERIODIC_CYCLE_UNIT
          },
          isHide: ({ form }) => form.type === "single" || active === "recruitment",
          required: form.type === "periodic"
        },
        {
          title: "정기 모집 주기",
          type: "number",
          key: "periodicDate",
          tooltip: "년 > 매년 n일째 되는 날\n월 > 매월 n일\n주 > 매 주 n요일(0: 일요일, 6: 토요일)\n일 > 주기에 관계없이 모임 시작~종료 시간에 세미나 실행",
          isHide: ({ form }) => form.type === "single" || active === "recruitment",
          required: form.type === "periodic" || active === "recruitment",
          validators: ['number']
        },
      ],
      [
        {
          title: "모집 시작",
          type: "datepicker",
          key: "reruitmentStartTime",
          tooltip: "정기의 경우 신청 가능한 기간의 시작 날짜가 됩니다.",
          required: true,
          isHide: () => active === "recruitment",
        },
        {
          title: "모집 종료",
          type: "datepicker",
          key: "reruitmentEndTime",
          tooltip: "정기의 경우 신청 가능한 기간의 종료 날짜가 됩니다.",
          required: true,
          isHide: () => active === "recruitment",
        },
      ],
      [
        {
          title: "모임 시작",
          type: "datetimepicker",
          key: "seminarStartTime",
          tooltip: "정기의 경우 세미나 시작 시간입니다.",
          required: true,
          isHide: () => active === "recruitment",
        },
        {
          title: "모임 종료",
          type: "datetimepicker",
          key: "seminarEndTime",
          tooltip: "정기의 경우 세미나 종료 시간입니다.",
          required: true,
          isHide: () => active === "recruitment",
        },
      ],
      {
        type: "line",
        isHide: ({ form }) => active === "recruitment" || form.type === "single"
      },

      {
        type: "title",
        title: "취소 / 변경 세미나 일정",
        isHide: ({ form }) => active === "recruitment" || form.type === "single"
      },
    ];
    return _fields;

  };

  useEffect(() => {
    if (!isEmpty(sessionList)) {
      setTimeout(() => {
        setFields(getFields());
      }, 10);
    }
  }, [mode, sessionList, categories, form, checkedList, active, cancelScheduleList]);

  useEffect(() => {
    if (!isEmpty(fields)) setValidateFields(fields);
  }, [fields]);

  useEffect(() => {
    handleOnChange({ categories: checkedList.map(item => ({ order: 0, idx: item })) });
  }, [checkedList]);

  useEffect(() => {
    if (!isEmpty(content)) {
      handleOnChange(content);
    }
  }, [content]);

  const tabList = [
    {
      label: "모집 설정",
      action: setActive,
      value: "recruitment",
    },
    {
      label: "날짜 설정",
      action: setActive,
      value: "date",
    },
  ];


  const handleRemoveList = (idx) => {
    let newArray = [...cancelScheduleList];


    newArray = newArray
      .filter((_schedule, scheduleIdx) => scheduleIdx !== idx)
      .map((item, _idx) => {
        const result = item;
        if (_idx >= idx) {
          const findObj = cancelScheduleList.find((f, fIdx) => fIdx === _idx + 1);
          result[`isChange_${_idx}`] = findObj[`isChange_${_idx + 1}`];
        }
        delete result[`isChange_${_idx + 1}`];
        return result;
      });
    setCancelScheduleList(newArray);
  };

  const addCancelSchedule = () => {
    const _cancelScheduleList = cancelScheduleList;
    const _defaultData = {
      ...defaultCancelSchedule,
      [`isChange_${_cancelScheduleList.length}`]: "false"
    };
    cancelScheduleList.length > 0 && delete _defaultData.isChange_0;
    _cancelScheduleList.push(_defaultData);
    setCancelScheduleList([..._cancelScheduleList]);
  };


  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {`세미나 모집 ${mode === "create" ? "등록" : "수정"}`}
        </ModalHeader>
        <TabList
          tabList={tabList}
          active={active}
        />
        <Form
          fields={fields}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          onChange={handleOnChange}
        // submitText={mode === 'create' ? '등록' : '수정'}
        // submit={handleSubmit}
        />

        {active === "date" && form?.type === "periodic" && (
          <div className='data-form clear data-form-create'>
            {!isEmpty(cancelScheduleList) &&
              cancelScheduleList.map((item, idx) => {
                return (
                  <React.Fragment key={idx}>
                    <div className="clear">
                      <div className="data-form-item items-multi items-total-2 first" style={{ width: "50%" }}>
                        <label class="data-form-label data-form-label-datetimepicker" style={{ width: "100px" }}>
                          <span class="field-title">
                            취소 일정
                          </span>
                          <span class="color-red-100">&nbsp;*</span>
                        </label>
                        <div className="form-component" style={{ width: "calc(100% - 100px)" }}>
                          <DatePicker
                            defaultValue={item.cancelDate.toString()}
                            onChange={(date) => {
                              if (item.cancelDate.toString() === date.datepicker.toString()) return;
                              let newArray = [...cancelScheduleList];
                              newArray[idx] = {
                                ...newArray[idx],
                                cancelDate: date.datepicker.toString()
                              };
                              setCancelScheduleList(newArray);
                            }}
                          />
                        </div>
                      </div>
                      <div className="data-form-item items-multi items-total-2" style={{ width: "50%" }}>
                        <label class="data-form-label data-form-label-datetimepicker" style={{ width: "100px" }}>
                          <span class="field-title">
                            변경 선택 여부
                          </span>
                          <span class="color-red-100">&nbsp;*</span>
                        </label>
                        <div className="form-component" style={{ width: "calc(100% - 100px)" }}>
                          <Radios field={{
                            options: {
                              list: [
                                { label: "취소", value: "false" },
                                { label: "변경", value: "true" },
                              ],
                            },
                            key: `isChange_${idx}`
                          }}
                            onChange={(e) => {
                              const { value } = e.target;
                              let newArray = [...cancelScheduleList];
                              newArray[idx] = {
                                ...newArray[idx],
                                [`isChange_${idx}`]: value
                              };
                              setCancelScheduleList(newArray);
                            }}
                            form={{ [`isChange_${idx}`]: item[`isChange_${idx}`] }}
                          />
                        </div>
                      </div>
                    </div>
                    {get(item, `isChange_${idx}`) === "true" && (
                      <div className="clear">
                        <div className="data-form-item items-multi items-total-2 first" style={{ width: "50%" }}>
                          <label class="data-form-label data-form-label-datetimepicker" style={{ width: "100px" }}>
                            <span class="field-title">
                              변경 일정 시작
                            </span>
                            <span class="color-red-100">&nbsp;*</span>
                          </label>
                          <div className="form-component" style={{ width: "calc(100% - 100px)" }}>
                            <DatePicker
                              data-enable-time
                              defaultValue={item.startDate.toString()}
                              onChange={(date) => {
                                if (item.startDate.toString() === date.datepicker.toString()) return;
                                let newArray = [...cancelScheduleList];
                                newArray[idx] = {
                                  ...newArray[idx],
                                  startDate: date.datepicker.toString()
                                };
                                setCancelScheduleList(newArray);
                              }}
                            />
                          </div>
                        </div>
                        <div className="data-form-item items-multi items-total-2" style={{ width: "50%" }}>
                          <label class="data-form-label data-form-label-datetimepicker" style={{ width: "100px" }}>
                            <span class="field-title">
                              변경 일정 종료
                            </span>
                            <span class="color-red-100">&nbsp;*</span>
                          </label>
                          <div className="form-component" style={{ width: "calc(100% - 100px)" }}>
                            <DatePicker
                              data-enable-time
                              defaultValue={item.endDate.toString()}
                              onChange={(date) => {
                                if (item.endDate.toString() === date.datepicker.toString()) return;
                                let newArray = [...cancelScheduleList];
                                newArray[idx] = {
                                  ...newArray[idx],
                                  endDate: date.datepicker.toString()
                                };
                                setCancelScheduleList(newArray);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <Button className="float-right delete-button" label="삭제하기" color="gray-line" onClick={() => handleRemoveList(idx)} />
                  </React.Fragment>
                );
              })}

            <Button
              size="sm"
              className="w-full mt-22 mb-22"
              color="gray-line"
              label="추가"
              onClick={addCancelSchedule}
            />
          </div>
        )}

        <div className="float-right clear text-align-right">
          <Button onClick={handleSubmit}>
            {mode === 'create' ? '등록' : '수정'}
          </Button>
        </div>
      </Modal>
      <Session
        open={sessionOpen}
        setOpen={setSessionOpen}
        submit={reloadFields}
      />
    </>

  );
};

export default Recruitment;